import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurl } from "../../../Baseurl";
import Swal from "sweetalert2";
import AdminSidebar from "../../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../../component/AdminComp/AdminTopbar";

const AllTrashCategory = () => {
  const [menus, setMenus] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${baseurl}getallMain`)
      .then((response) => {
        setMenus(response.data);
      })
      .catch((error) => console.error("Error fetching menus:", error));
  }, []);

  const handleEdit = (categoryId) => {
    navigate(`/admin/edit-category/${categoryId}`);
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${baseurl}deleteTrashMenuById/${id}`)
          .then(() => {
            Swal.fire("Deleted!", "Your menu has been deleted.", "success");
            setMenus(menus.filter((menu) => menu.id !== id));
          })
          .catch((error) => {
            console.error("Error deleting menu:", error);
            Swal.fire("Error!", "Something went wrong.", "error");
          });
      }
    });
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <h4 className="mb-3 text-start">All Trash Categories</h4>

          {/* Category Table */}
          <div className="crd1">
            <div className="table-responsive mt-4">
              <table className="custom-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Title</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {menus.map((menu) => (
                    <tr key={menu.id}>
                      <td>{menu.id}</td>
                      <td>{menu.title}</td>
                      <td>
                        <button className="btn btnedit me-2" onClick={() => handleEdit(menu.id)}>
                          Edit
                        </button>
                        <button className="btn btndelete" onClick={() => handleDelete(menu.id)}>
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllTrashCategory;
